import { render, staticRenderFns } from "./call-button.vue?vue&type=template&id=35e06f20&"
import script from "./call-button.vue?vue&type=script&lang=js&"
export * from "./call-button.vue?vue&type=script&lang=js&"
import style0 from "./call-button.vue?vue&type=style&index=0&id=35e06f20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzIconWhatsAppOutline: require('/opt/airport.kg/node_modules/razlet-ui/src/icons/icon-whats-app-outline/index.vue').default,RzIconPhoneWaves: require('/opt/airport.kg/node_modules/razlet-ui/src/icons/icon-phone-waves/index.vue').default})
